import { render, staticRenderFns } from "./BenefitEdit.vue?vue&type=template&id=3a851e9a"
import script from "./BenefitEdit.vue?vue&type=script&lang=js"
export * from "./BenefitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports